module.exports = __webpack_public_path__ + "img/banner-2.5bde4d4e.jpg";